import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { API_URL, scroll, getValFromLS, setValToLS } from "../helpers";
import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Radios from "../components/Radios";
import Checkboxes from "../components/Checkboxes";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const CharityRegDeandi = () => {
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({
    id: "0",
  });
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  const history = useHistory();

  useEffect(() => {
    scroll();
    init(getValFromLS("crId") || "0");
  }, []);

  const init = async (id) => {
    const url = new URL(`${API_URL}/crDeandiInit`);
    const params = {
      id,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json) {
        setNames({ ...json });
        setAlert({});
        if (json.resp === 0 && getValFromLS("crId")) {
          setValToLS("crId", "");
        }
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleCheckboxes = (name, checked, val) => {
    let newValue = "";
    if (checked) {
      newValue = val;
    }
    setNames((names) => ({ ...names, [name]: newValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/crDeandi`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      data.append(key, value);
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        setValToLS("crId", json.id);
        history.push("/registration");
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <div id="full-column">
      <Hdg section="Registration" />
      <Fragment>
        {alert.type ? (
          <Alert data={alert} />
        ) : (
          <Fragment>
            <h3>
              <i className="fa fa-file-text-o" /> &nbsp;PGA TOUR DE&I
            </h3>
            <p>
              The PGA TOUR is tracking across all of their tournaments,
              including the Valero Texas Open, how charities are utilizing the
              funds received from the tournament’s charitable initiatives (i.e.
              Champions fore Charity, incentives, etc.). Specifically, the PGA
              TOUR is tracking DE&I initiatives to support
              underserved/underrepresented and marginalized groups.
            </p>

            <p>
              Keeping this in mind, please answer for the following questions.
              Should you have any questions, please contact{" "}
              <a href="mailto:stephanie@valerotexasopen.com">
                Stephanie@ValeroTexasOpen.com
              </a>{" "}
              or at 210.345.3839.
            </p>

            <form
              method="post"
              action="/"
              onSubmit={(e) => handleSubmit(e)}
              className="well"
            >
              <div className="form-group one">
                <Input
                  name="people"
                  label="Based on your fundraising goal, how many people will be served by funds raised through Champions fore Charity?"
                  reqd={false}
                  value={names.people || ""}
                  update={handleUpdate}
                  errors={errors}
                />
              </div>

              <div className="form-group radios">
                <Radios
                  label="Does the proposed program serve at least 51% of an underserved population?"
                  reqd={false}
                  data={[
                    {
                      name: "underserved",
                      val: "Yes",
                      label: "Yes",
                    },
                    {
                      name: "underserved",
                      val: "No",
                      label: "No",
                    },
                  ]}
                  value={names.preferredMail || ""}
                  click={handleUpdate}
                />
              </div>

              <div className="form-group radios">
                <Radios
                  label="Are the percentage of people served by your organization at least 51% Black or African American citizens?"
                  reqd={false}
                  data={[
                    {
                      name: "percentage",
                      val: "Yes",
                      label: "Yes",
                    },
                    {
                      name: "percentage",
                      val: "No",
                      label: "No",
                    },
                  ]}
                  value={names.percentage || ""}
                  click={handleUpdate}
                />
              </div>

              <div
                className={
                  names.percentage === "No" ? "form-group radios" : "hidden"
                }
              >
                <Checkboxes
                  label="If no, what group(s) comprises of at least 51% of the people served?"
                  reqd={false}
                  data={[
                    {
                      name: "group1",
                      val: "American Indian or Alaska Native",
                      label: "",
                    },
                    {
                      name: "group2",
                      val: "Asian",
                      label: "",
                    },
                    {
                      name: "group3",
                      val: "Hispanic/Latino/Spanish",
                      label: "",
                    },
                    {
                      name: "group4",
                      val: "Native Hawaiian and Pacific Islander",
                      label: "",
                    },
                    {
                      name: "group5",
                      val: "White",
                      label: "",
                    },
                    {
                      name: "group6",
                      val: "Other",
                      label: "",
                    },
                    {
                      name: "group7",
                      val: "N/A",
                      label: "",
                    },
                  ]}
                  values={[
                    names.group1 || "",
                    names.group2 || "",
                    names.group3 || "",
                    names.group4 || "",
                    names.group5 || "",
                    names.group6 || "",
                    names.group7 || "",
                  ]}
                  click={handleCheckboxes}
                />
              </div>

              <div
                className={
                  names.group6 === "Other" ? "form-group radios" : "hidden"
                }
              >
                <Checkboxes
                  label="If you selected “Other,” does your program focus on any of the groups identified below?"
                  reqd={false}
                  data={[
                    {
                      name: "groupOther1",
                      val: "Persons with Disabilities",
                      label: "",
                    },
                    {
                      name: "groupOther2",
                      val: "LGBQT+",
                      label: "",
                    },
                    {
                      name: "groupOther3",
                      val: "Veterans",
                      label: "",
                    },
                    {
                      name: "groupOther4",
                      val: "Women",
                      label: "",
                    },
                  ]}
                  values={[
                    names.groupOther1 || "",
                    names.groupOther2 || "",
                    names.groupOther3 || "",
                    names.groupOther4 || "",
                  ]}
                  click={handleCheckboxes}
                />
              </div>

              <div className="form-group radios">
                <Checkboxes
                  label="How do you plan to use the funds?"
                  reqd={false}
                  data={[
                    {
                      name: "fund1",
                      val: "Programming",
                      label: "",
                    },
                    {
                      name: "fund2",
                      val: "Capacity Building",
                      label: "",
                    },
                    {
                      name: "fund3",
                      val: "Capital Project",
                      label: "",
                    },
                    {
                      name: "fund4",
                      val: "Event",
                      label: "",
                    },
                  ]}
                  values={[
                    names.fund1 || "",
                    names.fund2 || "",
                    names.fund3 || "",
                    names.fund4 || "",
                  ]}
                  click={handleCheckboxes}
                />
              </div>

              <div
                className={
                  names.fund4 === "Event" ? "form-group radios" : "hidden"
                }
              >
                <Radios
                  label="If “Event,” purpose of event:"
                  reqd={false}
                  data={[
                    {
                      name: "event",
                      val: "Fundraiser",
                      label: "Fundraiser",
                    },
                    {
                      name: "event",
                      val: "Community/Public Education",
                      label: "Community/Public Education",
                    },
                    {
                      name: "event",
                      val: "Entertainment",
                      label: "Entertainment",
                    },
                    {
                      name: "event",
                      val: "Awareness",
                      label: "Awareness",
                    },
                    {
                      name: "event",
                      val: "Other",
                      label: "Other",
                    },
                  ]}
                  value={names.event || ""}
                  click={handleUpdate}
                />
              </div>

              <div
                className={
                  names.event === "Other" ? "form-group one" : "hidden"
                }
                style={{ marginTop: "10px" }}
              >
                <Input
                  name="eventOther"
                  label="If you selected “Other,” please explain:"
                  reqd={false}
                  value={names.eventOther || ""}
                  update={handleUpdate}
                  errors={errors}
                />
              </div>

              <div className="form-group radios">
                <Checkboxes
                  label="Select Appropriate Category(ies):"
                  reqd={false}
                  data={[
                    {
                      name: "category1",
                      val: "Community/Economic Growth and Empowerment",
                      label: "",
                    },
                    {
                      name: "category2",
                      val: "Education",
                      label: "",
                    },
                    {
                      name: "category3",
                      val: "Health and Human Services",
                      label: "",
                    },
                    {
                      name: "category4",
                      val: "Racial Equity and Social Justice Advocacy",
                      label: "",
                    },
                    {
                      name: "category5",
                      val: "Youth Development",
                      label: "",
                    },
                    {
                      name: "category6",
                      val: "Other",
                      label: "",
                    },
                  ]}
                  values={[
                    names.category1 || "",
                    names.category2 || "",
                    names.category3 || "",
                    names.category4 || "",
                    names.category5 || "",
                    names.category6 || "",
                  ]}
                  click={handleCheckboxes}
                />
              </div>

              <div
                className={
                  names.category6 === "Other" ? "form-group one" : "hidden"
                }
                style={{ marginTop: "10px" }}
              >
                <Input
                  name="categoriesOther"
                  label="If you selected “Other,” please explain:"
                  reqd={false}
                  value={names.categoriesOther || ""}
                  update={handleUpdate}
                  errors={errors}
                />
              </div>

              <div className="msg-submit">
                {msg.type && <Msg data={msg} />}

                <div
                  className={
                    msg.type === "working" || msg.type === "success"
                      ? "hidden"
                      : "submit-container"
                  }
                >
                  <Submit
                    path="/registration"
                    left="Back"
                    submit="Submit PGA TOUR DE&I"
                  />
                </div>
              </div>
            </form>
          </Fragment>
        )}
      </Fragment>
    </div>
  );
};

export default CharityRegDeandi;
